var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videoOpen"},[_c('div',{staticClass:"nav-bar"},[_vm._v(" 视频详情 ")]),_c('div',{staticClass:"video",attrs:{"id":"J_video"}}),_c('div',{staticClass:"pendingConfirm",on:{"click":_vm.jumpBack}},[_vm._v("返回视频列表")])])}
var staticRenderFns = []

export { render, staticRenderFns }